import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

export default function Header() {
  const [openMenu, setOpenMenu] = useState(null);      // dropdown desktop
  const [mobileOpen, setMobileOpen] = useState(false); // menu mobile

  const handleMouseEnter = (menu) => setOpenMenu(menu);
  const handleMouseLeave = () => setOpenMenu(null);

  const closeMobileMenu = () => setMobileOpen(false);

  return (
    <header className="sticky top-0 z-50 h-20 md:h-24 bg-white bg-opacity-80 backdrop-blur-xl border-b border-gray-200 overflow-visible">
      {/* Subtle Pattern Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-white opacity-20 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-full">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center space-x-3 md:space-x-4 hover:opacity-80 transition-opacity"
          onClick={closeMobileMenu}
        >
          <img src="/logo.png" alt="Usina Rosa" className="h-10 md:h-16 w-auto" />
          <span className="text-2xl md:text-3xl font-bold text-green-800">
            Usina Rosa
          </span>
        </Link>

        {/* NAV DESKTOP */}
        <nav className="hidden md:flex flex-1 justify-center ml-8 lg:ml-12">
          <ul className="flex items-center justify-center space-x-8 lg:space-x-12 text-gray-800 font-semibold text-sm lg:text-lg">
            <li>
              <Link
                to="/"
                className="group relative hover:text-green-700 transition-colors"
              >
                Início
                <span className="absolute left-0 -bottom-1 w-0 h-1 bg-green-700 group-hover:w-full transition-all duration-300" />
              </Link>
            </li>

            {/* Quem Somos - DESKTOP */}
            <li
              onMouseEnter={() => handleMouseEnter('quem')}
              onMouseLeave={handleMouseLeave}
              className="relative"
            >
              <button
                type="button"
                className="flex items-center space-x-1 hover:text-green-700 transition-colors text-sm lg:text-lg font-semibold"
                aria-haspopup="menu"
                aria-expanded={openMenu === 'quem'}
              >
                <span>Quem Somos</span><span>▾</span>
              </button>

              <AnimatePresence>
                {openMenu === 'quem' && (
                  <motion.div
                    className="absolute top-full left-0 mt-2 bg-white rounded-2xl shadow-lg py-2 w-64 z-50"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    role="menu"
                  >
                    <a
                      href="/downloads/ROSA SA  APRESENTAÇÃO COMERCIAL.pdf"
                      download="ROSA SA  APRESENTAÇÃO COMERCIAL.pdf"
                      className="block px-4 py-2 hover:bg-green-50 text-sm"
                      role="menuitem"
                    >
                      Apresentação Comercial
                    </a>
                  </motion.div>
                )}
              </AnimatePresence>
            </li>

            <li>
              <Link
                to="/servicos"
                className="group relative hover:text-green-700 transition-colors"
              >
                Serviços
                <span className="absolute left-0 -bottom-1 w-0 h-1 bg-green-700 group-hover:w-full transition-all duration-300" />
              </Link>
            </li>

            <li>
              <Link
                to="/produtos"
                className="group relative hover:text-green-700 transition-colors"
              >
                Produtos
                <span className="absolute left-0 -bottom-1 w-0 h-1 bg-green-700 group-hover:w-full transition-all duration-300" />
              </Link>
            </li>

            <li>
              <Link
                to="/contato"
                className="group relative hover:text-green-700 transition-colors"
              >
                Contato
                <span className="absolute left-0 -bottom-1 w-0 h-1 bg-green-700 group-hover:w-full transition-all duration-300" />
              </Link>
            </li>
          </ul>
        </nav>

        {/* Whats + Hamburguer / Desktop */}
        <div className="flex items-center space-x-4 md:space-x-6 text-gray-800">
          {/* WhatsApp sempre visível */}
          <a
            href="https://wa.me/5519996318018"
            className="hover:text-green-700 transition-colors text-2xl md:text-2xl"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>

          {/* BOTÃO HAMBURGUER - MOBILE */}
          <button
            type="button"
            className={`md:hidden inline-flex items-center justify-center w-9 h-9 rounded-full border transition 
              ${mobileOpen ? 'bg-green-100 border-green-500' : 'bg-white/70 border-gray-300 hover:bg-green-50'}`}
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label="Abrir menu"
          >
            <span className="sr-only">Abrir menu</span>
            <div className="space-y-1.5">
              <span
                className={`block h-0.5 w-5 rounded-full transition-colors ${
                  mobileOpen ? 'bg-green-800' : 'bg-gray-800'
                }`}
              />
              <span
                className={`block h-0.5 w-5 rounded-full transition-colors ${
                  mobileOpen ? 'bg-green-800' : 'bg-gray-800'
                }`}
              />
              <span
                className={`block h-0.5 w-5 rounded-full transition-colors ${
                  mobileOpen ? 'bg-green-800' : 'bg-gray-800'
                }`}
              />
            </div>
          </button>
        </div>
      </div>

      {/* MENU MOBILE DROPDOWN */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.nav
            className="md:hidden relative z-40 bg-white/95 backdrop-blur-xl border-t border-gray-200"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            <ul className="flex flex-col px-4 py-3 space-y-2 text-gray-800 font-medium text-base">
              <li>
                <Link
                  to="/"
                  className="block py-2 hover:text-green-700"
                  onClick={closeMobileMenu}
                >
                  Início
                </Link>
              </li>
              <li>
                <a
                  href="/downloads/ROSA SA  APRESENTAÇÃO COMERCIAL.pdf"
                  download="ROSA SA  APRESENTAÇÃO COMERCIAL.pdf"
                  className="block py-2 hover:text-green-700"
                  onClick={closeMobileMenu}
                >
                  Apresentação Comercial
                </a>
              </li>
              <li>
                <Link
                  to="/servicos"
                  className="block py-2 hover:text-green-700"
                  onClick={closeMobileMenu}
                >
                  Serviços
                </Link>
              </li>
              <li>
                <Link
                  to="/produtos"
                  className="block py-2 hover:text-green-700"
                  onClick={closeMobileMenu}
                >
                  Produtos
                </Link>
              </li>
              <li>
                <Link
                  to="/contato"
                  className="block py-2 hover:text-green-700"
                  onClick={closeMobileMenu}
                >
                  Contato
                </Link>
              </li>
            </ul>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
